//All Payroll Types
import {
  GET_PAYROLL_TYPES_REQUEST,
  GET_PAYROLL_TYPES_SUCCESS,
  GET_PAYROLL_TYPES_ERROR,
} from "../../actions/payrolls/getPayrollTypes";

//All Payrolls
import {
  GET_PAYROLLS_REQUEST,
  GET_PAYROLLS_SUCCESS,
  GET_PAYROLLS_ERROR,
} from "../../actions/payrolls/getPayrolls";

//Payroll
import {
  GET_PAYROLL_REQUEST,
  GET_PAYROLL_SUCCESS,
  GET_PAYROLL_ERROR,
} from "../../actions/payrolls/getPayroll";

//Update Payroll
import {
  PUT_PAYROLL_REQUEST,
  PUT_PAYROLL_SUCCESS,
  PUT_PAYROLL_ERROR,
} from "../../actions/payrolls/putPayroll";

//Create Payroll
import {
  POST_PAYROLL_REQUEST,
  POST_PAYROLL_SUCCESS,
  POST_PAYROLL_ERROR,
} from "../../actions/payrolls/postPayroll";

//Logout
import { LOGOUT } from "../../../auth/actions/logout";

const INITIAL_STATE = {
  loading: false,
  loadingAction: false,
  error: false,
  data: [],
  pagination: {
    current_page: 0,
    last_page: 0,
    per_page: 0,
    total: 0,
  },
  detail: {},
  types: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLL_TYPES_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_PAYROLL_TYPES_SUCCESS:
      return {
        ...state,
        types: [...action.payload],
        error: false,
        loading: false,
      };
    case GET_PAYROLL_TYPES_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case GET_PAYROLLS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_PAYROLLS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: false,
        loading: false,
      };
    case GET_PAYROLLS_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case GET_PAYROLL_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_PAYROLL_SUCCESS:
      return {
        ...state,
        detail: action.payload,
        error: false,
        loading: false,
      };
    case GET_PAYROLL_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case PUT_PAYROLL_REQUEST:
      return {
        ...state,
        error: false,
        loadingAction: true,
      };
    case PUT_PAYROLL_SUCCESS:
      return {
        ...state,
        error: false,
        loadingAction: false,
      };
    case PUT_PAYROLL_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loadingAction: false,
      };
    case POST_PAYROLL_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case POST_PAYROLL_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };
    case POST_PAYROLL_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
